import { setFormFieldValue } from '../actions/forms';

export const decoratePayloadContactDetails = (inputs) => Object.keys(inputs)
    .reduce((acc, key) => {
        acc[key] = inputs[key].value;
        return acc;
    }, {});

export const populateFields = (form, data, dispatch) => {
    Object.keys(data)
        .forEach((field) => {
            dispatch(setFormFieldValue(form, field, data[field]));
        });
};
